// Core Imports
import React, { useState } from 'react';
import { Alert, Col, Row, Form } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ltrim from 'validator/lib/ltrim';
import rtrim from 'validator/lib/rtrim';
import isEmail from 'validator/lib/isEmail';

const ContactForm = () => {
  // Form State
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(null);
  const [name, setName] = useState(null);
  const [mobile, setMobile] = useState(null);
  const [message, setMessage] = useState(null);

  // Error Message JSX Element
  const mailError = error && <>{error}</>;

  // Handlers for form fields
  const handleName = (e) => {
    setName(e.target.value);
    setError(null);
  };

  const handleEmail = (e) => {
    let value = ltrim(rtrim(e.target.value));
    // Basic email validation
    if (!isEmail(value)) {
      setError(<Alert variant="danger">Please enter a valid email</Alert>);
      setDisabled(true);
    } else {
      setError(null);
      setDisabled(false);
    }
  };

  const handleMobile = (value) => {
    setMobile(value);
    setError(null);
  };

  const handleMessage = (e) => {
    setMessage(e.target.value);
    setError(null);
  };

  // Submit handler
  const handleFormSubmit = (e) => {
    e.preventDefault();

    // Simple client-side validation
    if (!name) {
      setError(<Alert variant="danger">Name Required</Alert>);
    } else if (!mobile) {
      setError(<Alert variant="danger">Contact Number Required</Alert>);
    } else if (!message) {
      setError(<Alert variant="danger">Message Required</Alert>);
    } else {
      setDisabled(true);

      // Placeholder for actual email API integration
      // Uncomment and customize to enable backend integration
      /*
      const data = { title, to_email, cc, template, subject };
      const config = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      };
      axios.post('https://api', data, config)
        .then(response => {
          document.getElementById('contact-us').reset();
          setDisabled(false);
          history.push('/thank-you');
        })
        .catch(error => {
          console.error(error);
          setDisabled(false);
        });
      */
    }
  };

  return (
    <div>
      <Form className="contact-form" id="contact-us" onSubmit={handleFormSubmit}>
        <Row>
          <Col md={12}>
            <TextField
              className="form-control mt-unset"
              label="Name"
              size="small"
              variant="outlined"
              required
              inputProps={{ minLength: 3, maxLength: 50 }}
              onChange={handleName}
            />
          </Col>

          <Col md={6}>
            <TextField
              className="form-control"
              label="Email"
              size="small"
              variant="outlined"
              inputProps={{ minLength: 3, maxLength: 100 }}
              onChange={handleEmail}
            />
          </Col>

          <Col md={6}>
            <PhoneInput
              country={'nz'}
              onChange={handleMobile}
              inputProps={{ minLength: 3, maxLength: 18, required: true }}
            />
          </Col>

          <Col md={12}>
            <TextField
              multiline
              rows={4}
              className="form-control"
              size="small"
              label="Message"
              variant="outlined"
              required
              inputProps={{ minLength: 3, maxLength: 200 }}
              onChange={handleMessage}
            />
          </Col>

          {mailError && (
            <Col md={12}>{mailError}</Col>
          )}

          <Col md={12}>
            <Button type="submit" disabled={disabled}>
              SEND MESSAGE
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ContactForm;